import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";

const RevenueCharts = ({ dataColors, series, categories }) => {
  var linechartcustomerColors = getChartColorsArray(dataColors);

  var options = {
    chart: {
      height: 370,
      type: "line",
      toolbar: { show: false },
      background: "transparent",
      foreColor: "#b3b3b3",
    },
    theme: { mode: "dark" },
    stroke: {
      curve: "smooth",
      dashArray: [4, 0, 4],
      width: [3, 3.5, 3],
      lineCap: "round",
    },
    fill: {
      type: "solid",
      opacity: 1,
    },
    markers: {
      size: [5, 6, 5],
      strokeWidth: 2.5,
      strokeColors: "#0a0a0a",
      hover: { size: 8 },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: categories,
      axisTicks: { show: false },
      axisBorder: { show: false },
      labels: { style: { colors: "#b3b3b3", fontFamily: '"Geist", sans-serif' } },
    },
    yaxis: {
      labels: { style: { colors: "#b3b3b3", fontFamily: '"Geist", sans-serif' } },
    },
    grid: {
      show: true,
      borderColor: "#262626",
      strokeDashArray: 3,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
      padding: { top: 0, right: 10, bottom: 15, left: 10 },
    },
    legend: {
      show: true,
      horizontalAlign: "center",
      offsetX: 0,
      offsetY: -5,
      labels: { colors: "#d4d4d4" },
      markers: { width: 9, height: 9, radius: 6 },
      itemMargin: { horizontal: 10, vertical: 0 },
    },
    tooltip: {
      theme: "dark",
      shared: true,
    },
    plotOptions: {
      bar: {
        columnWidth: "30%",
        barHeight: "70%",
      },
    },
    colors: linechartcustomerColors,
  };
  return (
    <React.Fragment>
      <ReactApexChart dir="ltr"
        options={options}
        series={series}
        type="line"
        height="370"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

const StoreVisitsCharts = ({ dataColors }) => {
  var chartDonutBasicColors = getChartColorsArray(dataColors);
  const series = [44, 55, 41, 17, 15];
  var options = {
    labels: ["Direct", "Social", "Email", "Other", "Referrals"],
    chart: {
      height: 333,
      type: "donut",
    },
    legend: {
      position: "bottom",
    },
    stroke: {
      show: false,
    },
    dataLabels: {
      dropShadow: {
        enabled: false,
      },
    },
    colors: chartDonutBasicColors,
  };
  return (
    <React.Fragment>
      <ReactApexChart dir="ltr"
        options={options}
        series={series}
        type="donut"
        height="333"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export { RevenueCharts, StoreVisitsCharts };
